import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, NavigationCategoryModel, NavigationCategoryViewModel, JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { NavigationApiService } from "../../core/api/services";
import { Table } from "primeng/table";
import { DomSanitizer } from "@angular/platform-browser";



@Component({
  selector: 'app-navigation-categories-component',
  templateUrl: './navigation-categories.component.html',
  standalone: false
})
export class NavigationCategoriesComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Navigation Links';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;
  
  itemFormGroup!: FormGroup;
  currentItem?: NavigationCategoryModel;

  get IconValue() {
    return this.itemFormGroup.controls["Icon"].value;
  }

  loading: boolean = false;
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: NavigationApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + ( params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading ' + ID);

      this.apiService.GetNavigationCategory({ body: { id: ID } })
        .forEach(data => {
          this.loadingList = false;
          this.currentItem = data;
          this.load();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

      }
    });


    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);


    this.itemFormGroup = this.formBuilder.group(
      {

        //ID: [],
        CategoryName: ['', [Validators.required, Validators.maxLength(50)]],
        HeaderName: ['', [Validators.maxLength(50)]],
        OrderNumber: [0, [Validators.required,]],
        URL: ['', [Validators.maxLength(50)]],
        IsPatientNav: [false, [Validators.required,]],
        Icon: ['', [Validators.maxLength(100)]]
      });


  }

  ngAfterViewInit(): void {
    
    /*
    this.filter = {
      filters: {
        "Active": [
          {
            "value": "true",
            "matchMode": "contains",
            "operator": "and"
          }
        ]
      }
    }; 
    ;
    */
    
  }



  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.ListNavigationCategories({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }


  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {

    this.currentItem = {
      ID: 0,
      OrderNumber: 99
    } as NavigationCategoryModel;
    this.load();

  }


  onRowView(item: NavigationCategoryViewModel) {
   
  }

  onRowEditInit(item: NavigationCategoryViewModel) {

    this.loadingList = true;


    this.apiService.GetNavigationCategory({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }


  onRowDeleteInit(item: NavigationCategoryViewModel) {
    this.alertService.confirm('Confirm', `Are you sure you want to delete ${item.CategoryName}?`).subscribe(response => {
      if (response) {
        this.apiService.DeleteNavigationCategory({ body: { id: item.ID || 0 } })
          .forEach(
            (ok) => {
              this.loadTable(null);
              this.alertService.success('Item deleted successfully');
            }).catch(
              (err) => {
                this.alertService.error(Utils.getAjaxError(err));
              });

      }
    });

  }


  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    this.itemFormGroup.patchValue(this.currentItem);

  }

  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(newItem);
    

    this.loading = true;
    this.apiService.SaveNavigationCategory({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }).catch (
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          
        });


  }

}
